import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core';
// eslint-disable-next-line no-restricted-imports
import { AlertProps as MuiAlertProps, Alert as MuiAlert, AlertTitle } from '@material-ui/lab';
import { Typography } from './Typography';

interface AlertProps extends MuiAlertProps {
  shown: boolean;
  title?: string;
  text?: string;
  children?: never;
}

export const Alert: React.FC<AlertProps> = ({ shown, title, text, ...rest }) => {
  const { alert } = useAlertStyles();

  return shown ? (
    <MuiAlert className={alert} {...rest}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {text && <Typography>{text}</Typography>}
    </MuiAlert>
  ) : null;
};

const useAlertStyles = makeStyles(() => createStyles({ alert: { margin: '12px 0' } }));
